import React, { useRef, useState } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { Button, Modal } from 'react-bootstrap'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Select from 'react-select'
import { bindActionCreators } from 'redux'
import { updateTxState } from '../actions'
import { saveChangesModalConfirmation, validateModalConfirmation } from '../actions/modal_confirmation'
import { convertTransactionMessage } from '../actions/status_converter'
import { transactionStateLabel } from '../utils/display_names'
import { TX_STATUS_COMPLETED, TX_STATUS_FAILED, TX_STATUS_RESTARTED } from '../config'
import SpinnerCircle from './spinner_circle'

export const ConfirmationModal = (props) => {
  const [reasons, setReasons] = useState([])
  const [counter, setCounter] = useState(5)
  const [notes, setNotes] = useState('')
  const ref = useRef()

  const [copied, setCopied] = useState(false)

  const handleAccessCodeCopied = () => {
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  const handleSaveChanges = () => {
    const { updateTxState, id, newState, saveChangesModalConfirmation, validateModalConfirmation, errorCode } = props
    if (ref.current) {
      const notes = ref.current.value.trim()
      const filteredReasons = reasons.map((n) => n.value)

      if (!filteredReasons) {
        validateModalConfirmation(false)
        return
      }

      const interval = setInterval(() => {
        if (counter - 1 < 0) {
          clearInterval(interval)
          props.close()
        } else {
          setCounter(counter - 1)
        }
      }, 1000)

      if (!props.error_code) {
        updateTxState(id, newState, { notes, reasons: filteredReasons })
        saveChangesModalConfirmation(newState)
        return
      }

      const body = { notes, error_code: props.error_code, reasons: filteredReasons }
      if (errorCode) {
        body.error_code = errorCode
      }
      updateTxState(id, newState, body)
      saveChangesModalConfirmation(newState)
    }
  }
  const handleOnNotesChange = (e) => {
    setNotes(e.target.value)
    const { validateModalConfirmation, isValidated } = props
    if (isValidated) {
      return
    }
    validateModalConfirmation(true)
  }

  const disabled = () => {
    if (props.children) {
      return !notes || !props.error_code
    } else {
      return !reasons || !notes
    }
  }

  const {
    isModalConfirmationOpen,
    close,
    title,
    newState,
    isTxChangesSaved,
    isValidated,
    errorMessage,
    responseData,
    cancel,
    transactionsDeclineDefinitions,
  } = props

  let modalText
  if (newState) {
    if (newState === TX_STATUS_FAILED) {
      modalText = <span className='bg-danger p-xxs text-uppercase'>{transactionStateLabel(newState)}</span>
    } else if (newState === TX_STATUS_COMPLETED) {
      modalText = <span className='bg-primary p-xxs text-uppercase'>{transactionStateLabel(newState)}</span>
    } else {
      modalText = <span className='bg-success p-xxs text-uppercase'>{transactionStateLabel(newState)}</span>
    }
  }

  const onHide = isTxChangesSaved ? () => close() : () => cancel()

  let frontEndResponseData = null
  if (responseData) {
    frontEndResponseData = convertTransactionMessage(responseData.message)
  }
  return (
    <Modal size={props.large !== null ? 'lg' : null} show={isModalConfirmationOpen} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {responseData && isTxChangesSaved ? (
          <>
            <div className='alert alert-success animated fadeIn'>{frontEndResponseData}</div>
            {newState === TX_STATUS_RESTARTED && responseData.sms_blocked && responseData.new_access_code && (
              <div className='alert alert-warning animated fadeIn'>
                <div>
                  <strong>SMS delivery blocked — action required</strong>
                </div>
                <div style={{ marginTop: 8 }}>{responseData.sms_blocked_message}</div>
                <div style={{ marginTop: 8 }}>
                  New access code:{' '}
                  <CopyToClipboard text={responseData.new_access_code.toUpperCase()} onCopy={handleAccessCodeCopied}>
                    <span
                      title='Copy access code'
                      style={{ cursor: 'pointer', fontFamily: 'monospace', marginRight: 6 }}
                      className='label label-success'
                    >
                      {responseData.new_access_code.toUpperCase()}
                    </span>
                  </CopyToClipboard>
                  {copied && <span style={{ color: 'green' }}>Copied!</span>}
                </div>
                <div style={{ marginTop: 8 }}>You must provide this access code to the customer directly.</div>
              </div>
            )}
          </>
        ) : (
          <div>
            <div>You are about to update transaction status to {modalText}</div>
            <div>{props.children}</div>

            {newState !== TX_STATUS_COMPLETED && (
              <>
                <label style={{ marginTop: 10 }}>Select transaction declined reason</label>
                {transactionsDeclineDefinitions && (
                  <Select
                    closeMenuOnSelect={false}
                    isMulti
                    name='colors'
                    options={transactionsDeclineDefinitions.map(({ reason }) => ({
                      label: reason,
                      value: reason,
                    }))}
                    className='basic-multi-select'
                    classNamePrefix='select'
                    onChange={(reasons) => setReasons(reasons)}
                  />
                )}
              </>
            )}

            <label style={{ marginTop: 10 }}>Notes</label>
            <textarea
              style={{ marginTop: 10 }}
              id='notes'
              name='notes'
              rows='4'
              ref={ref}
              className='form-control'
              required
              value={notes}
              onChange={(e) => handleOnNotesChange(e)}
            />
          </div>
        )}
        <div className='m-xs' />
        {!isValidated && <div className='alert alert-danger animated fadeIn'>Notes required</div>}
        {errorMessage && (
          <div className='alert alert-danger animated fadeIn'>
            <span>errorMessage</span>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer>
          {isTxChangesSaved ? (
            <span className={'btn btn-default'} onClick={() => close()}>
              <span>
                Close (<span>{counter}</span>)
              </span>
            </span>
          ) : (
            <Button onClick={() => cancel()} variant={'default'}>
              Cancel
            </Button>
          )}
          {!isTxChangesSaved && (
            <Button variant='primary' disabled={disabled()} onClick={() => handleSaveChanges()}>
              Save changes <SpinnerCircle isActive={props.isFetching} />
            </Button>
          )}
        </Modal.Footer>
      </Modal.Footer>
    </Modal>
  )
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  errorMessage: state.txState.errorMessage,
  responseData: state.txState.responseData,
  isFetching: state.txState.isFetching,
  isTxChangesSaved: state.modalConfirmation.isTxChangesSaved,
  isValidated: state.modalConfirmation.isValidated,
  newState: state.modalConfirmation.newState,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateTxState,
      saveChangesModalConfirmation,
      validateModalConfirmation,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ConfirmationModal))
